import { types } from '../../types/types';
import { startSpinner, finishSpinner } from "../ui/spinner";
import ContratacionesService from '../../services/ContratacionesService';
import { handleErrorApi } from '../../helpers/randoms';


//ACA VAN A ESTAR TODOS LOS REPORTES DE LA SECCION REPORTES

export const fetchModulosPorEfectorFacturacion = (idEfectorFacturacion) => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.traerModulosPorContratoStart })
  try {
    const response = await ContratacionesService.traerModulosPorEfectorFacturacion(idEfectorFacturacion)
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.traerModulosPorContratoSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    dispatch({ type: types.traerModulosPorContratoError })
    handleErrorApi(dispatch, error, "Error al traer los contratos", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const guardarModuloPorEfectorFacturacion = (data, handleAfter) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
    const {dataContrato}=getState().contrataciones
    const response = await ContratacionesService.guardarModuloPorEfectorFacturacion(dataContrato.idEfectorFacturacion, data)
    const body = await response.json();
    if (response.ok) {
      dispatch(finishSpinner());
      handleAfter()
      dispatch(fetchModulosPorEfectorFacturacion(dataContrato.idEfectorFacturacion))
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    handleErrorApi(dispatch, error, "Error al guardar MODULO", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const eliminarModuloPorEfectorFacturacion = (idModulo, handleAfter) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
    const {dataContrato}=getState().contrataciones

    const response = await ContratacionesService.eliminarModuloPorEfectorFacturacion(dataContrato.idEfectorFacturacion, idModulo)
    const body = await response.json();
    if (response.ok) {
      dispatch(finishSpinner());
      handleAfter()
      dispatch(fetchModulosPorEfectorFacturacion(dataContrato.idEfectorFacturacion))
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    handleErrorApi(dispatch, error, "Error al eliminar modulo", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const generatePDFModulosPorEfectorFacturacion = (idEfectorFacturacion) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesService.generarPdfModulosPorEfectorFacturacion(idEfectorFacturacion);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      window.open(URL.createObjectURL(body));

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generateExcelModulosPorEfectorFacturacion = (idEfectorFacturacion)  => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesService.generarExcelModulosPorEfectorFacturacion(idEfectorFacturacion);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download = `Reporte practicas por modulos - ${idEfectorFacturacion}.xlsx`;
        a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};